import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export class ScreenProps {
  size: number;
  menuCollapsed: boolean;

  constructor(size: number, menuCollapsed: boolean) {
    this.size = size;
    this.menuCollapsed = menuCollapsed;
  }
}

@Injectable({ providedIn: 'root' })
export class UiService {
  // screenProps$ = new BehaviorSubject<ScreenProps | undefined>(undefined);
  private _screenProps$: BehaviorSubject<ScreenProps>;
  public screenProps$: Observable<ScreenProps>;
  private readonly SMARTPHONE_MAX_WIDTH = 600;
  private readonly TABLET_MAX_WIDTH = 1024;

  constructor() {
    this._screenProps$ = new BehaviorSubject({
      size: window.innerWidth,
      menuCollapsed: window.innerWidth <= this.SMARTPHONE_MAX_WIDTH,
    });
    this.screenProps$ = this._screenProps$.asObservable();
  }

  isSmartphone() {
    return this._screenProps$.value.size <= this.SMARTPHONE_MAX_WIDTH;
  }

  isTablet() {
    return (
      this._screenProps$.value.size > this.SMARTPHONE_MAX_WIDTH &&
      this._screenProps$.value.size <= this.TABLET_MAX_WIDTH
    );
  }

  isDesktop() {
    return this._screenProps$.value.size > this.TABLET_MAX_WIDTH;
  }

  isMenuCollapsed() {
    return this._screenProps$.value.menuCollapsed === true;
  }

  setMenuCollapsed(b: boolean) {
    this._screenProps$.next({ ...this._screenProps$.value, menuCollapsed: b });
  }

  toggleMenuCollapsed() {
    this._screenProps$.next({ ...this._screenProps$.value, menuCollapsed: !this.isMenuCollapsed() });
  }
}
